export const extraServicesModule = {
  state: () => ({
    list: [
      {
        isAvilable: false,
        name: 'parking',
        id: 1643,
        title: 'Парковка',
        data: {
          isSelected: false,
          dateStart: '',
          dateEnd: '',
          additional: '',
          totalPrice: 0,
        },
      },
      {
        isAvilable: false,
        name: 'transfer',
        id: 1653,
        title: 'Трансфер',
        data: {
          isSelected: false,
          dateStart: '',
          dateEnd: '',
          additional: '',
          totalPrice: 0,
        },
      },
    ],
  }),

  getters: {
    getTotalPrice: state => {
      return state.list.reduce((acc, cur) => {
        if(cur.id !== null && cur.id !== undefined && cur.data.isSelected) {
          acc += +cur.data.totalPrice
        }
        return acc
      }, 0)
    },

    getAvilable: (state, getters, rootState, rootGetters) => {
      /* проверка, если выбранная категория размещения принадлежит к красному яру, то допы недоступны */
      // let yarIds = rootState.dictionaries.krasniyYarIds
      let selectedCategoryId = rootState.selection.selectedCategoryId
      let getCategoryData = rootGetters[`dictionaries/getRoomCategoryById`]
      let selectedCategoryData = getCategoryData(selectedCategoryId)
      let res = []
      // if(yarIds.findIndex(i => String(i) === String(selectedCategoryId)) === -1) {
      if(+selectedCategoryData.divisionId !== 2) {
        res = state.list.filter(o => o.isAvilable)
      }
      return res
    },

    getSelectedExtraServices: (state, getters, rootState, rootGetters) => {
      /* проверка, если выбранная категория размещения принадлежит к красному яру, то допы недоступны */
      // let yarIds = rootState.dictionaries.krasniyYarIds
      let selectedCategoryId = rootState.selection.selectedCategoryId
      let getCategoryData = rootGetters[`dictionaries/getRoomCategoryById`]
      let selectedCategoryData = getCategoryData(selectedCategoryId)
      let res = []
      // if(yarIds.findIndex(i => String(i) === String(selectedCategoryId)) === -1) {
      if(+selectedCategoryData.divisionId === 2) {
        state.list.filter(obj => obj.data.isSelected === true)
      }
      return res
    },
  },

  mutations: {
    updateExtraService(state, payload) {
      let findedObj = state.list.find(obj => obj.name === payload.name).data
      if(findedObj) {
        Object.assign(findedObj, payload.data);
      }
    },

    setAvilable(state, payload) {
      let finded = state.list.find(o => o.name === payload.name)
      if(finded) {
        finded.isAvilable = payload.bool
      }
    }
  },

  actions: {
    // addExtraService({commit, rootState}, data) {
    //   let dictionaryService = rootState.dictionaries.extraServices.find(obj => obj.id === data.id)


    // },

    updateExtraService({commit}, payload) {
      commit('updateExtraService', payload)
    }
  },

  namespaced: true,
}
